// semeia-disable-reexport
import { template } from "@ember/template-compiler";
import { hash, fn } from '@ember/helper';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import incrementalList from 'parog-web/helpers/incremental-list';
export interface S<Item> {
    Args: {
        chunkSize: Parameters<typeof incrementalList>[1];
        items: Parameters<typeof incrementalList>[0];
        disabled?: NonNullable<Parameters<typeof incrementalList>[2]>['disabled'];
    };
    Blocks: {
        default: [items: ReturnType<typeof incrementalList>];
    };
}
/**
 * This component now and forwards its responsability to the "incrementalList" resource
 *
 * Its only responsibility is to hold a "isComplete" state that will be set to true
 * when the incremental building is finished
 *
 * This is useful to avoid a rebuild of an entire DOM when the @items array is changed
 * after the incremental build has finished. In a use-case like this, the #each inside the
 * <IncrementalList> block would take care of DOM updates and we do not want to re-render the
 * entire incremental list and make the UI glitch
 */ export default class IncrementalList<Item> extends Component<S<Item>> {
    /** Internal flag set to true when the incremental build is finished */ @tracked
    isComplete = false;
    static{
        template(`
    {{#if this.isComplete}}
      {{yield (incrementalList @items @chunkSize (hash disabled=true))}}
    {{else}}
      {{yield
        (incrementalList
          @items
          @chunkSize
          (hash disabled=@disabled onComplete=(fn (mut this.isComplete) true))
        )
      }}
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
